import { Divider, Grid, Typography } from "@mui/material";
import CustomListRow from "components/display/customListRow";
import { useTranslation } from "utils/locales/utilityFunctions";
import { ListItemProps } from "features/files/components/filesMainCard";

type FilesSectionProps = {
  files: ListItemProps[][];
  disabled?: boolean;
};

const FilesSection = ({ files, disabled }: FilesSectionProps) => {
  const { translate } = useTranslation();
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ mb: 0 }}>
          {translate("biomass-project-form-files")}
        </Typography>
      </Grid>

      <Grid item xs={12} sx={{ mb: 0 }}>
        <Divider />
        {files.map((row, i) => {
          return (
            <CustomListRow
              row={row}
              key={"labelText" + i}
              i={i}
              disabled={disabled}
            />
          );
        })}
      </Grid>
    </>
  );
};

export default FilesSection;